import { StatusColumn } from 'src/components/wttp/common/table/columns/status';
import { Maybe, WttpQuestionStatus } from 'src/graphql/generated/graphql';

export const StatusField = ({
  status,
  isActive,
}: {
  status?: WttpQuestionStatus | Maybe<WttpQuestionStatus>;
  isActive: boolean;
}) => {
  return <StatusColumn status={status} isActive={isActive} />;
};
